import i18next from "i18next";

export interface ProgressTip {
  id: string;
  element: string;
  title: string;
  description: string;
  side: "top" | "bottom" | "left" | "right" | "over";
  align: "start" | "center" | "end";
  autoDismissMs: number;
}

interface ProgressTipDef {
  id: string;
  element: string;
  titleKey: string;
  descKey: string;
  side: "top" | "bottom" | "left" | "right" | "over";
  align: "start" | "center" | "end";
  autoDismissMs: number;
}

const PROGRESS_DEFS: Record<string, ProgressTipDef> = {
  "prog-room-created": {
    id: "prog-room-created",
    element: "#button-products",
    titleKey: "tips.progress.roomCreatedTitle",
    descKey: "tips.progress.roomCreatedDesc",
    side: "right",
    align: "start",
    autoDismissMs: 6000,
  },
  "prog-first-product": {
    id: "prog-first-product",
    element: "#designer-canvas",
    titleKey: "tips.progress.firstProductTitle",
    descKey: "tips.progress.firstProductDesc",
    side: "top",
    align: "center",
    autoDismissMs: 6000,
  },
  "prog-3d-preview": {
    id: "prog-3d-preview",
    element: "#button-room-style",
    titleKey: "tips.progress.threeDPreviewTitle",
    descKey: "tips.progress.threeDPreviewDesc",
    side: "right",
    align: "start",
    autoDismissMs: 6000,
  },
  "prog-material-changed": {
    id: "prog-material-changed",
    element: "#button-products",
    titleKey: "tips.progress.materialChangedTitle",
    descKey: "tips.progress.materialChangedDesc",
    side: "right",
    align: "start",
    autoDismissMs: 6000,
  },
};

export function getProgressTip(tipId: string): ProgressTip | undefined {
  const def = PROGRESS_DEFS[tipId];
  if (!def) return undefined;
  return {
    id: def.id,
    element: def.element,
    title: i18next.t(def.titleKey),
    description: i18next.t(def.descKey),
    side: def.side,
    align: def.align,
    autoDismissMs: def.autoDismissMs,
  };
}

export const progressTipIds = Object.keys(PROGRESS_DEFS);
